/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, FUNCTIONS){
	const a = 'is-active';
	const v = 'is-visible';
	let $path = location.pathname;
	let yearLabels;
	let brPosition;
	let txtRotation;
	let label1, label2, label3, label4;
	let lang;
	if($path.split('/')[1] === 'english') {
		lang = 'english';
		yearLabels= ['FY Ended Nov. 2016', 'FY Ended Nov. 2017', 'FY Ended Nov. 2018', 'FY Ended Nov. 2019', 'FY Ended Nov. 2020'];
		brPosition = 8;
		txtRotation = 45;
		label1 = 'Consolidated Basis';
		label2 = 'Non-Consolidated Basis';
		label3 = 'Consolidated basis (net income attributable to shareholders of the parent company)';
		label4 = 'Non-consolidated basis (current net income)';
	} else {
		lang = 'corporate';
		yearLabels= ['2016年11月期', '2017年11月期', '2018年11月期', '2019年11月期', '2020年11月期'];
		brPosition = 5;
		txtRotation = 0;
		label1 = '連結';
		label2 = '単体';
		label3 = '連結（親会社株主に帰属する当期純利益）';
		label4 = '単体（当期純利益）';
	}
	// ===== FUNCTIONS start ===================================================================

	let years, highlights_1_1, highlights_1_2, highlights_2_1, highlights_2_2, highlights_3_1, highlights_3_2, highlights_4_1, highlights_4_2, highlights_5_1, highlights_5_2, highlights_6_1, highlights_6_2, highlights_7_1, highlights_7_2, highlights_8_1, stocks_info_1_1, stocks_info_1_2, stocks_returns_1_1, stocks_returns_1_2, tr01, tr02, stocks_returns_dataSide, highlights_1_dataSide, highlights_2_dataSide, highlights_3_dataSide, highlights_4_dataSide, highlights_5_dataSide, highlights_6_dataSide, highlights_7_dataSide, highlights_8_dataSide;

	// <業績ハイライト> ========================================
	let highlighCSVPath;
	if($path.split('/')[1] === 'english') {
		highlighCSVPath = '/english/csv/ir_management_highlights.csv';
	} else {
		highlighCSVPath = '/corporate/csv/ir_management_highlights.csv';
	}
	if($path === '/'+lang+'/ir/management/highlights.html') {
		const req = new XMLHttpRequest();
		req.open('get', highlighCSVPath, true);
		req.send(null);
		req.onload = function(){
			let tmp = req.responseText.split('\n');
			tmp.forEach((val, idx) => {
				const data = val.split(',').filter(Boolean);
				const data2 =  data.filter(Boolean);
				// 共通ラベル
				if(idx === 0) {
					data2.splice(0,2);
					data2.splice(5);
					years = data2;
					console.log(years, 'years');
				}
				// 売上高(連結)
				if(data2.indexOf('売上高(連結)') !== -1) {
					highlights_1_dataSide = data2.splice(7); // スケール格納
					data2.splice(0,2);
					data2.splice(5);
					highlights_1_1 = data2;
					console.log(highlights_1_1, 'highlights_1_1');
				}
				if(data2.indexOf('Sales(Consolidated Basis)') !== -1) {
					highlights_1_dataSide = data2.splice(7); // スケール格納
					data2.splice(0,2);
					data2.splice(5);
					highlights_1_1 = data2;
					console.log(highlights_1_1, 'highlights_1_1');
				}
				// 売上高(単体)
				if(data2.indexOf('売上高(単体)') !== -1) {
					data2.splice(0,1);
					data2.splice(5);
					highlights_1_2 = data2;
					console.log(highlights_1_2, 'highlights_1_2');
				}
				if(data2.indexOf('Sales(Non-Consolidated Basis)') !== -1) {
					data2.splice(0,1);
					data2.splice(5);
					highlights_1_2 = data2;
					console.log(highlights_1_2, 'highlights_1_2');
				}
				// 営業利益(連結)
				if(data2.indexOf('営業利益(連結)') !== -1) {
					highlights_2_dataSide = data2.splice(7); // スケール格納
					data2.splice(0,2);
					data2.splice(5);
					highlights_2_1 = data2;
					console.log(highlights_2_1, 'highlights_2_1');
				}
				if(data2.indexOf('Operating Profit(Consolidated Basis)') !== -1) {
					highlights_2_dataSide = data2.splice(7); // スケール格納
					data2.splice(0,2);
					data2.splice(5);
					highlights_2_1 = data2;
					console.log(highlights_2_1, 'highlights_2_1');
				}
				// 営業利益(単体)
				if(data2.indexOf('営業利益(単体)') !== -1) {
					data2.splice(0,1);
					data2.splice(5);
					highlights_2_2 = data2;
					console.log(highlights_2_2, 'highlights_2_2');
				}
				if(data2.indexOf('Operating Profit(Non-Consolidated Basis)') !== -1) {
					data2.splice(0,1);
					data2.splice(5);
					highlights_2_2 = data2;
					console.log(highlights_2_2, 'highlights_2_2');
				}
				// 経常利益(連結)
				if(data2.indexOf('経常利益(連結)') !== -1) {
					highlights_3_dataSide = data2.splice(7); // スケール格納
					data2.splice(0,2);
					data2.splice(5);
					highlights_3_1 = data2;
					console.log(highlights_3_1, 'highlights_3_1');
				}
				if(data2.indexOf('Ordinary Profit(Consolidated Basis)') !== -1) {
					highlights_3_dataSide = data2.splice(7); // スケール格納
					data2.splice(0,2);
					data2.splice(5);
					highlights_3_1 = data2;
					console.log(highlights_3_1, 'highlights_3_1');
				}
				// 経常利益(単体)
				if(data2.indexOf('経常利益(単体)') !== -1) {
					data2.splice(0,1);
					data2.splice(5);
					highlights_3_2 = data2;
					console.log(highlights_3_2, 'highlights_3_2');
				}
				if(data2.indexOf('Ordinary Profit(Non-Consolidated Basis)') !== -1) {
					data2.splice(0,1);
					data2.splice(5);
					highlights_3_2 = data2;
					console.log(highlights_3_2, 'highlights_3_2');
				}
				// 当期純利益(連結)
				if(data2.indexOf('当期純利益(連結)') !== -1) {
					highlights_4_dataSide = data2.splice(7); // スケール格納
					data2.splice(0,2);
					data2.splice(5);
					highlights_4_1 = data2;
					console.log(highlights_4_1, 'highlights_4_1');
				}
				if(data2.indexOf('Current Net Profit(Consolidated basis (net income attributable to shareholders of the parent company))') !== -1) {
					highlights_4_dataSide = data2.splice(7); // スケール格納
					data2.splice(0,2);
					data2.splice(5);
					highlights_4_1 = data2;
					console.log(highlights_4_1, 'highlights_4_1');
				}
				// 当期純利益(単体)
				if(data2.indexOf('当期純利益(単体)') !== -1) {
					data2.splice(0,1);
					data2.splice(5);
					highlights_4_2 = data2;
					console.log(highlights_4_2, 'highlights_4_2');
				}
				if(data2.indexOf('Current Net Profit(Non-consolidated basis (current net income))') !== -1) {
					data2.splice(0,1);
					data2.splice(5);
					highlights_4_2 = data2;
					console.log(highlights_4_2, 'highlights_4_2');
				}
				// 総資産(連結)
				if(data2.indexOf('総資産(連結)') !== -1) {
					highlights_5_dataSide = data2.splice(7); // スケール格納
					data2.splice(0,2);
					data2.splice(5);
					highlights_5_1 = data2;
					console.log(highlights_5_1, 'highlights_5_1');
				}
				if(data2.indexOf('Total Assets(Consolidated Basis)') !== -1) {
					highlights_5_dataSide = data2.splice(7); // スケール格納
					data2.splice(0,2);
					data2.splice(5);
					highlights_5_1 = data2;
					console.log(highlights_5_1, 'highlights_5_1');
				}
				// 総資産(単体)
				if(data2.indexOf('総資産(単体)') !== -1) {
					data2.splice(0,1);
					data2.splice(5);
					highlights_5_2 = data2;
					console.log(highlights_5_2, 'highlights_5_2');
				}
				if(data2.indexOf('Total Assets(Non-Consolidated Basis)') !== -1) {
					data2.splice(0,1);
					data2.splice(5);
					highlights_5_2 = data2;
					console.log(highlights_5_2, 'highlights_5_2');
				}
				// 純資産(連結)
				if(data2.indexOf('純資産(連結)') !== -1) {
					highlights_6_dataSide = data2.splice(7); // スケール格納
					data2.splice(0,2);
					data2.splice(5);
					highlights_6_1 = data2;
					console.log(highlights_6_1, 'highlights_6_1');
				}
				if(data2.indexOf('Net Assets(Consolidated Basis)') !== -1) {
					highlights_6_dataSide = data2.splice(7); // スケール格納
					data2.splice(0,2);
					data2.splice(5);
					highlights_6_1 = data2;
					console.log(highlights_6_1, 'highlights_6_1');
				}
				// 純資産(単体)
				if(data2.indexOf('純資産(単体)') !== -1) {
					data2.splice(0,1);
					data2.splice(5);
					highlights_6_2 = data2;
					console.log(highlights_6_2, 'highlights_6_2');
				}
				if(data2.indexOf('Net Assets(Non-Consolidated Basis)') !== -1) {
					data2.splice(0,1);
					data2.splice(5);
					highlights_6_2 = data2;
					console.log(highlights_6_2, 'highlights_6_2');
				}
				// 自己資本比率(連結)
				if(data2.indexOf('自己資本比率(連結)') !== -1) {
					highlights_7_dataSide = data2.splice(7); // スケール格納
					data2.splice(0,2);
					data2.splice(5);
					highlights_7_1 = data2;
					console.log(highlights_7_1, 'highlights_7_1');
				}
				if(data2.indexOf('Capital Adequacy Ratio(Consolidated Basis)') !== -1) {
					highlights_7_dataSide = data2.splice(7); // スケール格納
					data2.splice(0,2);
					data2.splice(5);
					highlights_7_1 = data2;
					console.log(highlights_7_1, 'highlights_7_1');
				}
				// 自己資本比率(単体)
				if(data2.indexOf('自己資本比率(単体)') !== -1) {
					data2.splice(0,1);
					data2.splice(5);
					highlights_7_2 = data2;
					console.log(highlights_7_2, 'highlights_7_2');
				}
				if(data2.indexOf('Capital Adequacy Ratio(Non-Consolidated Basis)') !== -1) {
					data2.splice(0,1);
					data2.splice(5);
					highlights_7_2 = data2;
					console.log(highlights_7_2, 'highlights_7_2');
				}
				// ROE(連結)
				if(data2.indexOf('ROE(連結)') !== -1) {
					highlights_8_dataSide = data2.splice(7); // スケール格納
					data2.splice(0,2);
					data2.splice(5);
					highlights_8_1 = data2;
					console.log(highlights_8_1, 'highlights_8_1');
				}
				if(data2.indexOf('ROE(Consolidated Basis)') !== -1) {
					highlights_8_dataSide = data2.splice(7); // スケール格納
					data2.splice(0,2);
					data2.splice(5);
					highlights_8_1 = data2;
					console.log(highlights_8_1, 'highlights_8_1');
				}
			});
			// <業績ハイライト>(売上高) グラフ描画
			const chartCreateHighlights01 = () => {
				const ctx = document.getElementById('jsCharthighlights01').getContext('2d');
				ctx.canvas.height = 300;
				Chart.defaults.global.defaultFontColor = '#000';
				let myBarChart01 = new Chart(ctx, {
					type: 'bar',
					data: {
						labels: years,
						datasets: [{
							label: label1,
							data: highlights_1_1,
							backgroundColor: '#0e307e',
							yAxisID: 'y-axis-1',
						}, {
							label: label2,
							data: highlights_1_2,
							backgroundColor: '#54b7df',
							yAxisID: 'y-axis-2',
						}]
					},
					options: {
						tooltips: {
							mode: 'nearest',
							intersect: false,
							callbacks: {
								label: function(tooltipItem, data){
									var label = data.datasets[tooltipItem.datasetIndex].label || '';

									if (label) {
										label += ': ';
									}
									label += tooltipItem.yLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
									return label;
								}
							}
						},
						responsive: true,
						scales: {
							yAxes: [{
								id: 'y-axis-1',
								type: 'linear',
								position: 'left',
								ticks: {
									max: Number(highlights_1_dataSide[0]),
									min: Number(highlights_1_dataSide[1]),
									stepSize: Number(highlights_1_dataSide[2]),
									callback: function(val){
										return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
									}
								},
								gridLines: {
									color: '#ddd',
									zeroLineColor: '#000',
									drawBorder: false
								},
							}, {
								id: 'y-axis-2',
								type: 'linear',
								position: 'left',
								ticks: {
									display: false,
									max: Number(highlights_1_dataSide[0]),
									min: Number(highlights_1_dataSide[1]),
									stepSize: Number(highlights_1_dataSide[2]),
								},
								gridLines: {
									display: false,
								},
							}],
							xAxes: [{
								gridLines: {
									color: 'transparent',
									zeroLineColor: 'transparent'
								},
								barPercentage: 0.7,
								ticks: {
									maxRotation: txtRotation,
									minRotation: 0,
									callback: function(val){
										if(val.length > brPosition) {
											return [val.substr(0, brPosition), val.substr(brPosition)];
										} else {
											return val;
										}
									}
								}
							}]
						},
						legend: {
							position: 'bottom'
						}
					}
				});
			};
			// <業績ハイライト>(営業利益) グラフ描画
			const chartCreateHighlights02 = () => {
				const ctx = document.getElementById('jsCharthighlights02').getContext('2d');
				ctx.canvas.height = 300;
				Chart.defaults.global.defaultFontColor = '#000';

				let myBarChart02 = new Chart(ctx, {
					type: 'bar',
					data: {
						labels: years,
						datasets: [{
							label: label1,
							data: highlights_2_1,
							backgroundColor: '#0e307e',
							yAxisID: 'y-axis-1',
						}, {
							label: label2,
							data: highlights_2_2,
							backgroundColor: '#54b7df',
							yAxisID: 'y-axis-2',
						}]
					},
					options: {
						tooltips: {
							mode: 'nearest',
							intersect: false,
							callbacks: {
								label: function(tooltipItem, data){
									var label = data.datasets[tooltipItem.datasetIndex].label || '';

									if (label) {
										label += ': ';
									}
									label += tooltipItem.yLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
									return label;
								}
							}
						},
						responsive: true,
						scales: {
							yAxes: [{
								id: 'y-axis-1',
								type: 'linear',
								position: 'left',
								ticks: {
									max: Number(highlights_2_dataSide[0]),
									min: Number(highlights_2_dataSide[1]),
									stepSize: Number(highlights_2_dataSide[2]),
									callback: function(val){
										return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
									}
								},
								gridLines: {
									color: '#ddd',
									zeroLineColor: '#000',
									drawBorder: false
								},
							}, {
								id: 'y-axis-2',
								type: 'linear',
								position: 'left',
								ticks: {
									display: false,
									max: Number(highlights_2_dataSide[0]),
									min: Number(highlights_2_dataSide[1]),
									stepSize: Number(highlights_2_dataSide[2]),
								},
								gridLines: {
									display: false,
								},
							}],
							xAxes: [{
								gridLines: {
									color: 'transparent',
									zeroLineColor: 'transparent'
								},
								barPercentage: 0.7,
								ticks: {
									maxRotation: txtRotation,
									minRotation: 0,
									callback: function(val){
										if(val.length > brPosition) {
											return [val.substr(0, brPosition), val.substr(brPosition)];
										} else {
											return val;
										}
									}
								}
							}]
						},
						legend: {
							position: 'bottom'
						}
					}
				});
			};
			// <業績ハイライト>(経常利益) グラフ描画
			const chartCreateHighlights03 = () => {
				const ctx = document.getElementById('jsCharthighlights03').getContext('2d');
				ctx.canvas.height = 300;
				Chart.defaults.global.defaultFontColor = '#000';

				let myBarChart03 = new Chart(ctx, {
					type: 'bar',
					data: {
						labels: years,
						datasets: [{
							label: label1,
							data: highlights_3_1,
							backgroundColor: '#0e307e',
							yAxisID: 'y-axis-1',
						}, {
							label: label2,
							data: highlights_3_2,
							backgroundColor: '#54b7df',
							yAxisID: 'y-axis-2',
						}]
					},
					options: {
						tooltips: {
							mode: 'nearest',
							intersect: false,
							callbacks: {
								label: function(tooltipItem, data){
									var label = data.datasets[tooltipItem.datasetIndex].label || '';

									if (label) {
										label += ': ';
									}
									label += tooltipItem.yLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
									return label;
								}
							}
						},
						responsive: true,
						scales: {
							yAxes: [{
								id: 'y-axis-1',
								type: 'linear',
								position: 'left',
								ticks: {
									max: Number(highlights_3_dataSide[0]),
									min: Number(highlights_3_dataSide[1]),
									stepSize: Number(highlights_3_dataSide[2]),
									callback: function(val){
										return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
									}
								},
								gridLines: {
									color: '#ddd',
									zeroLineColor: '#000',
									drawBorder: false
								},
							}, {
								id: 'y-axis-2',
								type: 'linear',
								position: 'left',
								ticks: {
									display: false,
									max: Number(highlights_3_dataSide[0]),
									min: Number(highlights_3_dataSide[1]),
									stepSize: Number(highlights_3_dataSide[2]),
								},
								gridLines: {
									display: false,
								},
							}],
							xAxes: [{
								gridLines: {
									color: 'transparent',
									zeroLineColor: 'transparent'
								},
								barPercentage: 0.7,
								ticks: {
									maxRotation: txtRotation,
									minRotation: 0,
									callback: function(val){
										if(val.length > brPosition) {
											return [val.substr(0, brPosition), val.substr(brPosition)];
										} else {
											return val;
										}
									}
								}
							}]
						},
						legend: {
							position: 'bottom'
						}
					}
				});
			};
			// <業績ハイライト>(当期純利益) グラフ描画
			const chartCreateHighlights04 = () => {
				const ctx = document.getElementById('jsCharthighlights04').getContext('2d');
				ctx.canvas.height = 300;
				Chart.defaults.global.defaultFontColor = '#000';

				let myBarChart04 = new Chart(ctx, {
					type: 'bar',
					data: {
						labels: years,
						datasets: [{
							label: label3,
							data: highlights_4_1,
							backgroundColor: '#0e307e',
							yAxisID: 'y-axis-1',
						}, {
							label: label4,
							data: highlights_4_2,
							backgroundColor: '#54b7df',
							yAxisID: 'y-axis-2',
						}]
					},
					options: {
						tooltips: {
							mode: 'nearest',
							intersect: false,
							callbacks: {
								label: function(tooltipItem, data){
									var label = data.datasets[tooltipItem.datasetIndex].label || '';

									if (label) {
										label += ': ';
									}
									label += tooltipItem.yLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
									return label;
								}
							}
						},
						responsive: true,
						scales: {
							yAxes: [{
								id: 'y-axis-1',
								type: 'linear',
								position: 'left',
								ticks: {
									max: Number(highlights_4_dataSide[0]),
									min: Number(highlights_4_dataSide[1]),
									stepSize: Number(highlights_4_dataSide[2]),
									callback: function(val){
										return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
									}
								},
								gridLines: {
									color: '#ddd',
									zeroLineColor: '#000',
									drawBorder: false
								},
							}, {
								id: 'y-axis-2',
								type: 'linear',
								position: 'left',
								ticks: {
									display: false,
									max: Number(highlights_4_dataSide[0]),
									min: Number(highlights_4_dataSide[1]),
									stepSize: Number(highlights_4_dataSide[2]),
								},
								gridLines: {
									display: false,
								},
							}],
							xAxes: [{
								gridLines: {
									color: 'transparent',
									zeroLineColor: 'transparent'
								},
								barPercentage: 0.7,
								ticks: {
									maxRotation: txtRotation,
									minRotation: 0,
									callback: function(val){
										if(val.length > brPosition) {
											return [val.substr(0, brPosition), val.substr(brPosition)];
										} else {
											return val;
										}
									}
								}
							}]
						},
						legend: {
							position: 'bottom'
						}
					}
				});
			};
			// <業績ハイライト>(総資産) グラフ描画
			const chartCreateHighlights05 = () => {
				const ctx = document.getElementById('jsCharthighlights05').getContext('2d');
				ctx.canvas.height = 300;
				Chart.defaults.global.defaultFontColor = '#000';

				let myBarChart05 = new Chart(ctx, {
					type: 'bar',
					data: {
						labels: years,
						datasets: [{
							label: label1,
							data: highlights_5_1,
							backgroundColor: '#0e307e',
							yAxisID: 'y-axis-1',
						}, {
							label: label2,
							data: highlights_5_2,
							backgroundColor: '#54b7df',
							yAxisID: 'y-axis-2',
						}]
					},
					options: {
						tooltips: {
							mode: 'nearest',
							intersect: false,
							callbacks: {
								label: function(tooltipItem, data){
									var label = data.datasets[tooltipItem.datasetIndex].label || '';

									if (label) {
										label += ': ';
									}
									label += tooltipItem.yLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
									return label;
								}
							}
						},
						responsive: true,
						scales: {
							yAxes: [{
								id: 'y-axis-1',
								type: 'linear',
								position: 'left',
								ticks: {
									max: Number(highlights_5_dataSide[0]),
									min: Number(highlights_5_dataSide[1]),
									stepSize: Number(highlights_5_dataSide[2]),
									callback: function(val){
										return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
									}
								},
								gridLines: {
									color: '#ddd',
									zeroLineColor: '#000',
									drawBorder: false
								},
							}, {
								id: 'y-axis-2',
								type: 'linear',
								position: 'left',
								ticks: {
									display: false,
									max: Number(highlights_5_dataSide[0]),
									min: Number(highlights_5_dataSide[1]),
									stepSize: Number(highlights_5_dataSide[2]),
								},
								gridLines: {
									display: false,
								},
							}],
							xAxes: [{
								gridLines: {
									color: 'transparent',
									zeroLineColor: 'transparent'
								},
								barPercentage: 0.7,
								ticks: {
									maxRotation: txtRotation,
									minRotation: 0,
									callback: function(val){
										if(val.length > brPosition) {
											return [val.substr(0, brPosition), val.substr(brPosition)];
										} else {
											return val;
										}
									}
								}
							}]
						},
						legend: {
							position: 'bottom'
						}
					}
				});
			};
			// <業績ハイライト>(純資産) グラフ描画
			const chartCreateHighlights06 = () => {
				const ctx = document.getElementById('jsCharthighlights06').getContext('2d');
				ctx.canvas.height = 300;
				Chart.defaults.global.defaultFontColor = '#000';

				let myBarChart06 = new Chart(ctx, {
					type: 'bar',
					data: {
						labels: years,
						datasets: [{
							label: label1,
							data: highlights_6_1,
							backgroundColor: '#0e307e',
							yAxisID: 'y-axis-1',
						}, {
							label: label2,
							data: highlights_6_2,
							backgroundColor: '#54b7df',
							yAxisID: 'y-axis-2',
						}]
					},
					options: {
						tooltips: {
							mode: 'nearest',
							intersect: false,
							callbacks: {
								label: function(tooltipItem, data){
									var label = data.datasets[tooltipItem.datasetIndex].label || '';

									if (label) {
										label += ': ';
									}
									label += tooltipItem.yLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
									return label;
								}
							}
						},
						responsive: true,
						scales: {
							yAxes: [{
								id: 'y-axis-1',
								type: 'linear',
								position: 'left',
								ticks: {
									max: Number(highlights_6_dataSide[0]),
									min: Number(highlights_6_dataSide[1]),
									stepSize: Number(highlights_6_dataSide[2]),
									callback: function(val){
										return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
									}
								},
								gridLines: {
									color: '#ddd',
									zeroLineColor: '#000',
									drawBorder: false
								},
							}, {
								id: 'y-axis-2',
								type: 'linear',
								position: 'left',
								ticks: {
									display: false,
									max: Number(highlights_6_dataSide[0]),
									min: Number(highlights_6_dataSide[1]),
									stepSize: Number(highlights_6_dataSide[2]),
								},
								gridLines: {
									display: false,
								},
							}],
							xAxes: [{
								gridLines: {
									color: 'transparent',
									zeroLineColor: 'transparent'
								},
								barPercentage: 0.7,
								ticks: {
									maxRotation: txtRotation,
									minRotation: 0,
									callback: function(val){
										if(val.length > brPosition) {
											return [val.substr(0, brPosition), val.substr(brPosition)];
										} else {
											return val;
										}
									}
								}
							}]
						},
						legend: {
							position: 'bottom'
						}
					}
				});
			};
			// <業績ハイライト>(自己資本比率) グラフ描画
			const chartCreateHighlights07 = () => {
				const ctx = document.getElementById('jsCharthighlights07').getContext('2d');
				ctx.canvas.height = 300;
				Chart.defaults.global.defaultFontColor = '#000';

				let myBarChart07 = new Chart(ctx, {
					type: 'line',
					data: {
						labels: years,
						datasets: [{
							label: label1,
							data: highlights_7_1,
							borderColor: '#0e307e',
							yAxisID: 'y-axis-1',
							fill: false,
							lineTension: 0,
							backgroundColor: '#0e307e',
						}, {
							label: label2,
							data: highlights_7_2,
							borderColor: '#54b7df',
							yAxisID: 'y-axis-2',
							fill: false,
							lineTension: 0,
							backgroundColor: '#54b7df',
						}]
					},
					options: {
						tooltips: {
							mode: 'nearest',
							intersect: false,
							callbacks: {
								label: function(tooltipItem, data){
									var label = data.datasets[tooltipItem.datasetIndex].label || '';

									if (label) {
										label += ': ';
									}
									label += tooltipItem.yLabel.toFixed(1);
									return label;
								}
							}
						},
						responsive: true,
						scales: {
							yAxes: [{
								id: 'y-axis-1',
								position: 'left',
								ticks: {
									max: Number(highlights_7_dataSide[0]),
									min: Number(highlights_7_dataSide[1]),
									stepSize: Number(highlights_7_dataSide[2]),
								},
								gridLines: {
									color: '#ddd',
									zeroLineColor: '#000',
									drawBorder: false
								},
							}, {
								id: 'y-axis-2',
								position: 'left',
								ticks: {
									display: false,
									max: Number(highlights_7_dataSide[0]),
									min: Number(highlights_7_dataSide[1]),
									stepSize: Number(highlights_7_dataSide[2]),
								},
								gridLines: {
									display: false,
								},
							}],
							xAxes: [{
								gridLines: {
									display: false,
									color: 'transparent',
									zeroLineColor: 'transparent'
								},
								barPercentage: 0.7,
								ticks: {
									maxRotation: txtRotation,
									minRotation: 0,
									callback: function(val){
										if(val.length > brPosition) {
											return [val.substr(0, brPosition), val.substr(brPosition)];
										} else {
											return val;
										}
									}
								}
							}]
						},
						legend: {
							position: 'bottom'
						}
					}
				});
			};
			// <業績ハイライト>(ROE) グラフ描画
			const chartCreateHighlights08 = () => {
				const ctx = document.getElementById('jsCharthighlights08').getContext('2d');
				ctx.canvas.height = 300;
				Chart.defaults.global.defaultFontColor = '#000';

				let myBarChart08 = new Chart(ctx, {
					type: 'line',
					data: {
						labels: years,
						datasets: [{
							label: label1,
							data: highlights_8_1,
							borderColor: '#0e307e',
							backgroundColor: '#0e307e',
							fill: false,
							lineTension: 0
						}]
					},
					options: {
						tooltips: {
							mode: 'nearest',
							intersect: false,
							callbacks: {
								label: function(tooltipItem, data){
									var label = data.datasets[tooltipItem.datasetIndex].label || '';

									if (label) {
										label += ': ';
									}
									label += tooltipItem.yLabel.toFixed(1);
									return label;
								}
							}
						},
						responsive: true,
						scales: {
							yAxes: [{
								id: 'y-axis-1',
								position: 'left',
								ticks: {
									max: Number(highlights_8_dataSide[0]),
									min: Number(highlights_8_dataSide[1]),
									stepSize: Number(highlights_8_dataSide[2]),
								},
								gridLines: {
									color: '#ddd',
									zeroLineColor: '#000',
									drawBorder: false
								},
							}],
							xAxes: [{
								gridLines: {
									color: 'transparent',
									zeroLineColor: 'transparent'
								},
								barPercentage: 0.7,
								ticks: {
									maxRotation: txtRotation,
									minRotation: 0,
									callback: function(val){
										if(val.length > brPosition) {
											return [val.substr(0, brPosition), val.substr(brPosition)];
										} else {
											return val;
										}
									}
								}
							}]
						},
						legend: {
							position: 'bottom'
						}
					}
				});
			};
			// 業績ハイライト(売上高)
			if($('#jsCharthighlights01').length) {
				chartCreateHighlights01();
			}
			// 業績ハイライト(営業利益)
			if($('#jsCharthighlights02').length) {
				chartCreateHighlights02();
			}
			// 業績ハイライト(経常利益)
			if($('#jsCharthighlights03').length) {
				chartCreateHighlights03();
			}
			// 業績ハイライト(当期純利益)
			if($('#jsCharthighlights04').length) {
				chartCreateHighlights04();
			}
			// 業績ハイライト(総資産)
			if($('#jsCharthighlights05').length) {
				chartCreateHighlights05();
			}
			// 業績ハイライト(純資産)
			if($('#jsCharthighlights06').length) {
				chartCreateHighlights06();
			}
			// 業績ハイライト(自己資本比率)
			if($('#jsCharthighlights07').length) {
				chartCreateHighlights07();
			}
			// 業績ハイライト(ROE)
			if($('#jsCharthighlights08').length) {
				chartCreateHighlights08();
			}
		};
	}

	// <株式基本情報> ========================================
	let stocks_infoCSVPath;
	if($path.split('/')[1] === 'english') {
		stocks_infoCSVPath = '/english/csv/ir_stocks_info.csv';
	} else {
		stocks_infoCSVPath = '/corporate/csv/ir_stocks_info.csv';
	}
	if($path === '/'+lang+'/ir/stocks/info.html') {
		const req2 = new XMLHttpRequest();
		req2.open('get', stocks_infoCSVPath, true);
		req2.send(null);
		req2.onload = function(){
			let tmp = req2.responseText.split('\n');
			tmp.forEach((val, idx) => {
				// console.log(data,'data');
				const data = val.split(',').filter(Boolean);
				const data2 =  data.filter(Boolean);
				// console.log(data2,'data2');
				// 売上高(連結)
				if(data2.indexOf('株主構成') !== -1) {
					data2.splice(0,2);
					stocks_info_1_1 = data2;
					console.log(stocks_info_1_1, 'stocks_info_1_1');
					stocks_info_1_1.forEach((value, index, array) => {
						// 数字だけ取り出す
						let num = value.replace(/[^0-9]/g, '');
						// 数値化
						num = Number(num);
						// カンマ区切りの数字にする
						let commaNum = num.toLocaleString();
						value = value.replace(num, commaNum);
						stocks_info_1_1[index] = value;
					});
				}
				if(data2.indexOf('Shareholder Composition') !== -1) {
					data2.splice(0,2);
					stocks_info_1_1 = data2;
					console.log(stocks_info_1_1, 'stocks_info_1_1');
					stocks_info_1_1.forEach((value, index, array) => {
						// 数字だけ取り出す
						let num = value.replace(/[^0-9]/g, '');
						// 数値化
						num = Number(num);
						// カンマ区切りの数字にする
						let commaNum = num.toLocaleString();
						value = value.replace(num, commaNum);
						stocks_info_1_1[index] = value;
					});
				}
				if(data2.indexOf('株主構成(％)') !== -1) {
					data2.splice(0,1);
					stocks_info_1_2 = data2;
					console.log(stocks_info_1_2, 'stocks_info_1_2');
				}
				if(data2.indexOf('Shareholder Composition(%)') !== -1) {
					data2.splice(0,1);
					stocks_info_1_2 = data2;
					console.log(stocks_info_1_2, 'stocks_info_1_2');
				}
			});
			// <株式基本情報> グラフ描画
			const chartCreateInfo = () => {
				let labelArr;
				// if($path.split('/')[1] === 'english') {
				// 	labelArr = ['Individual and Others(8,652 thousand shares)', 'Financial Institutions(4,438 thousand shares)', 'Other Domestic Corporations(2,746 thousand shares)', 'Foreign Investors(1,502 thousand shares)'];
				// } else {
				// 	labelArr = ['個人その他（8,652千株）', '金融機関等（4,438千株）', 'その他の国内法人（2,746千株）', '外国人（1,502千株）'];
				// }
				var ctx = document.getElementById('jsChartInfo').getContext('2d');
				if(window.innerWidth < 768) {
					ctx.canvas.height = 200;
				} else if(window.innerWidth < 1280) {
					ctx.canvas.height = 100;
					if($path.split('/')[1] === 'english') {
						ctx.canvas.height = 200;
					}
				} else {
					ctx.canvas.height = 60;
					if($path.split('/')[1] === 'english') {
						ctx.canvas.height = 100;
					}
				}
				let stocks_info_1_2_0 = stocks_info_1_2[0];
				let stocks_info_1_2_1 = stocks_info_1_2[1];
				let stocks_info_1_2_2 = stocks_info_1_2[2];
				let stocks_info_1_2_3 = stocks_info_1_2[3];
				var myPieChart = new Chart(ctx, {
					type: 'horizontalBar',
					data: {
						datasets: [
						{ barPercentage: 0.5, label: stocks_info_1_1[0], data: [stocks_info_1_2_0], backgroundColor: "#253a81" },
						{ barPercentage: 0.5, label: stocks_info_1_1[1], data: [stocks_info_1_2_1], backgroundColor: "#54b7df" },
						{ barPercentage: 0.5, label: stocks_info_1_1[2], data: [stocks_info_1_2_2], backgroundColor: "#61c29c" },
						{ barPercentage: 0.5, label: stocks_info_1_1[3], data: [stocks_info_1_2_3], backgroundColor: "#23b24b" }
						]
					},
					options: {
						scales: {
							xAxes: [{
								stacked: true
							}],
							yAxes: [{
								stacked: true
							}]
						},
						tooltips: {
							callbacks: {
								title: function() {},
								label: function (tooltipItem, data){
									var totalValue = 0;
									for (var i = 0; i < data.datasets.length; i++) {
											totalValue += Number(data.datasets[i].data[tooltipItem.index]);
									}
									return data.datasets[tooltipItem.datasetIndex].label
									+ ": "
									+ data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]
									+ " %";
								}
							}
						}
					},
				});
			};
			// 株式基本情報
			if($('#jsChartInfo').length) {
				chartCreateInfo();
			}
		};
	}
	// <株主還元> ========================================
	let stocks_returnsCSVPath;
	if($path.split('/')[1] === 'english') {
		stocks_returnsCSVPath = '/english/csv/ir_stocks_returns.csv';
	} else {
		stocks_returnsCSVPath = '/corporate/csv/ir_stocks_returns.csv';
	}
	if($path === '/'+lang+'/ir/stocks/returns.html') {
		const req3 = new XMLHttpRequest();
		req3.open('get', stocks_returnsCSVPath, true);
		req3.send(null);
		req3.onload = function(){
			let tmp = req3.responseText.split('\n');
			tmp.forEach((val, idx) => {
				const data = val.split(',').filter(Boolean);
				const data2 =  data.filter(Boolean);
				// 共通ラベル
				if(idx === 0) {
					data2.splice(0,2);
					data2.splice(10);
					years = data2;
					// console.log(years, 'years');
				}
				if(data2.indexOf('配当の状況(配当性向（%）)') !== -1) {
					data2.splice(0,1);
					data2.splice(10);
					stocks_returns_1_1 = data2;
					// console.log(stocks_returns_1_1, 'stocks_returns_1_1');
				}
				if(data2.indexOf('Dividend payment(Dividend payout ratio (%))') !== -1) {
					data2.splice(0,1);
					data2.splice(10);
					stocks_returns_1_1 = data2;
					// console.log(stocks_returns_1_1, 'stocks_returns_1_1');
				}
				if(data2.indexOf('配当の状況(1株当たり配当金（円）)（年間）') !== -1) {
					data2.splice(0,1);
					data2.splice(10);
					stocks_returns_1_2 = data2;
					// console.log(stocks_returns_1_2, 'stocks_returns_1_2');
				}
				if(data2.indexOf('Dividend payment(Dividend per share (yen))(Annual)') !== -1) {
					data2.splice(0,1);
					data2.splice(10);
					stocks_returns_1_2 = data2;
					// console.log(stocks_returns_1_2, 'stocks_returns_1_2');
					stocks_returns_1_2.forEach((value, index, array) => {
						// 小数点以下2を表示
						let num = Number(value).toFixed(2);
						// 文字列化
						let textnum = String(num);
						stocks_returns_1_2[index] = textnum;
					});
				}
				// table描画
				if($('.js-ir_stocks_returns-tbl').length) {
					if(data2.indexOf('配当の状況(1株当たり配当金（円）)（中間）') !== -1) {
						stocks_returns_dataSide = data2.splice(12); // スケール格納
						data2.splice(0,2);
						data2.splice(10);
						tr01 = data2;
						// console.log(tr01, 'tr01');
					}
					if(data2.indexOf('Dividend payment(Dividend per share (yen))(Interim)') !== -1) {
						stocks_returns_dataSide = data2.splice(12); // スケール格納
						data2.splice(0,2);
						data2.splice(10);
						tr01 = data2;
						// console.log(tr01, 'tr01');
					}
					if(data2.indexOf('配当の状況(1株当たり配当金（円）)（期末）') !== -1) {
						data2.splice(0,1);
						data2.splice(10);
						tr02 = data2;
						// console.log(tr02, 'tr02');
					}
					if(data2.indexOf('Dividend payment(Dividend per share (yen))(Year-end)') !== -1) {
						data2.splice(0,1);
						data2.splice(10);
						tr02 = data2;
						// console.log(tr02, 'tr02');
					}
				}
			});
			// table描画
			if($('.js-ir_stocks_returns-tbl').length) {
				for(let i=9; i>=0; i--) {
					$('.js-ir_stocks_returns-tbl').append('<tr>'+
					'<td class="ta_left">'+years[i]+'</td>'+
					'<td>'+Number(tr01[i]).toFixed(2)+'</td>'+
					'<td>'+Number(tr02[i]).toFixed(2)+'</td>'+
					'<td>'+Number(stocks_returns_1_2[i]).toFixed(2)+'</td>'+
					'<td>'+Number(stocks_returns_1_1[i]).toFixed(1)+'</td>'+
					'</tr>');
				}
			}
			// <株主還元> グラフ描画
			const chartCreateReturns = () => {
				const ctx = document.getElementById('jsChartReturns');
				Chart.defaults.global.defaultFontColor = '#000';
				
				let thisLabelsArr,label1,label2;
				if($path.split('/')[1] === 'english') {
					thisLabelsArr = ['FY Ended Nov. 2012', 'FY Ended Nov. 2013', 'FY Ended Nov. 2014', 'FY Ended Nov. 2015', 'FY Ended Nov. 2016', 'FY Ended Nov. 2017', 'FY Ended Nov. 2018', 'FY Ended Nov. 2019', 'FY Ended Nov. 2020', 'FY Ended Nov. 2021(Forecast)'];
					label1 = 'Dividend payout ratio (%)';
					label2 = 'Dividend per share (yen)';
				} else {
					thisLabelsArr = ['2012年11月期', '2013年11月期', '2014年11月期', '2015年11月期', '2016年11月期', '2017年11月期', '2018年11月期', '2019年11月期', '2020年11月期', '2021年11月期（予想）'];
					label1 = '配当性向（%）';
					label2 = '1株当たり配当金（円）';
				}
				let myBarChart02 = new Chart(ctx, {
					type: 'bar',
					data: {
						labels: years,
						datasets: [{
							label: label1,
							type: 'line',
							tension: 0,
							fill: false,
							data: stocks_returns_1_1,
							borderColor: '#0e307e',
							backgroundColor: '#0e307e',
							yAxisID: 'y-axis-1',
						}, {
							label: label2,
							data: stocks_returns_1_2,
							backgroundColor: '#54b7df',
							yAxisID: 'y-axis-2',
						}]
					},
					options: {
						tooltips: {
							mode: 'nearest',
							intersect: false,
							callbacks: {
								label: function(tooltipItem, data){
									var label = data.datasets[tooltipItem.datasetIndex].label || '';

									if (label) {
										label += ': ';
									}
									if(data.datasets[tooltipItem.datasetIndex].label === '配当性向（%）') {
										label += tooltipItem.yLabel.toFixed(1);
									} else if(data.datasets[tooltipItem.datasetIndex].label === 'Dividend payout ratio (%)') {
										label += tooltipItem.yLabel.toFixed(1);
									} else {
										label += tooltipItem.yLabel.toFixed(2);
									}
									return label;
								}
							}
						},
						responsive: true,
						scales: {
							yAxes: [{
								id: 'y-axis-1',
								type: 'linear',
								position: 'left',
								ticks: {
									max: Number(stocks_returns_dataSide[0]),
									min:  Number(stocks_returns_dataSide[1]),
									stepSize: Number(stocks_returns_dataSide[2]),
								},
								gridLines: {
									color: 'transparent',
									zeroLineColor: '#000'
								}
							}, {
								id: 'y-axis-2',
								type: 'linear',
								position: 'right',
								ticks: {
									display: false,
									max: Number(stocks_returns_dataSide[0]),
									min:  Number(stocks_returns_dataSide[1]),
									stepSize: Number(stocks_returns_dataSide[2]),
								},
								gridLines: {
									display: false,
									drawOnChartArea: false,
									color: 'transparent',
									zeroLineColor: '#000'
								}
							}],
							xAxes: [{
								gridLines: {
									color: 'transparent',
									zeroLineColor: '#000'
								},
								barPercentage: 0.5,
								ticks: {
									maxRotation: 0,
									minRotation: 0,
									callback: function(val){
										if(val.length > brPosition) {
											return [val.substr(0, brPosition), val.substr(brPosition)];
										} else {
											return val;
										}
									}
								}
							}]
						}
					}
				});
			};
			// 株主還元
			if($('#jsChartReturns').length) {
				chartCreateReturns();
			}
		};
	}

	// <木といえば、ノダ。> ========================================
	const brandAnimation = () => {
		// メインビジュアル
		$(document).ready(function(){
			$('.js-anime-main').addClass(v);
		});
		// 各セクション
		$('.js-anime-block').each((idx, ele) => {
			$(ele).waypoint(function(direction){
				if(direction === 'down') {
					$(ele).addClass(v);
				}
			}, { offset : '70%' });
		});
	};

	// ===== FUNCTIONS end ===================================================================

	// 木といえば、ノダ。 ========================================
	if($path === '/corporate/brand/' || $path === '/corporate/brand/index.html' ||
	 $path === '/english/brand/' || $path === '/english/brand/index.html') {
		brandAnimation();
	}

})(window.jQuery, window.FUNCTIONS);
